import React, { Component } from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactTable from 'react-table'

import PropTypes from 'prop-types';

import "react-table/react-table.css";
import './ModalListaDeProductos.scss'

class ModalListaDeProductos extends Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        isOpenModal: PropTypes.bool.isRequired,
        productosComedor: PropTypes.array.isRequired,
        toggleModalOpen: PropTypes.func.isRequired,
    }

    render() {
        const {
            productosComedor,
            isOpenModal,
            toggleModalOpen,
        } = this.props;

        return (
            <Modal
                isOpen={isOpenModal}
                toggle={toggleModalOpen}
                className={"modal-primary modal-lista-productos"}
            >
                <ModalHeader>
                    <i className="fa fa-file-text-o mr-1" />  Lista de Productos
                </ModalHeader>
                <ModalBody>
                    <ReactTable
                        data={productosComedor}
                        columns={[
                            {
                                Header: "Productos",
                                columns: [
                                    {
                                        Header: "id",
                                        id: "id",
                                        accessor: d => d.id,
                                        show: false,
                                        private: true,
                                        width: 90
                                    },
                                    {
                                        Header: "Stock",
                                        id: "stock",
                                        accessor: d => d.stock,
                                        className: 'col-stock',
                                        width: 100,
                                        getHeaderProps: () => ({
                                            style: { textAlign: 'left' }
                                        }),
                                    },
                                    {
                                        Header: "Nombre",
                                        id: "nombre",
                                        accessor: d => d.nombre,
                                        className: 'col-nombre',
                                        show: true,
                                        minWidth: 100,
                                        getHeaderProps: () => ({
                                            style: { textAlign: 'left' }
                                        }),
                                    },
                                ],
                            }
                        ]}
                        noDataText="(No quedaron productos en este comedor)"
                        showPagination={false}
                        defaultPageSize={1000}
                        minRows={productosComedor.length == 0 ? 5 : productosComedor.length}
                        defaultSorted={[
                            {
                                id: 'nombre',
                                desc: false,
                            },
                        ]}
                    />

                </ModalBody>
                <ModalFooter>
                    <Button className="rounded" color="secondary" onClick={toggleModalOpen}>Volver</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default ModalListaDeProductos;



// WEBPACK FOOTER //
// ./src/views/PedidosProducto/ModalListaDeProductos.js